export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_h9kquant.png",
      alt: "Nome da extensão",
    },
    title: "Opere com a H9K Quant",
    text: [
      "Com a H9K Quant, você automatiza seus trades e ganha tempo para o que realmente importa. Nossos robôs operam com estratégia, controle de risco e precisão, aproveitando as melhores oportunidades do mercado sem que você precise ficar preso à tela. ",
      "Transparência e performance são a nossa base. Automatize, diversifique e leve seu trading para o próximo nível. ",
    ],
    testimonial: {
      text: "O longo prazo é construído no dia a dia. Cada trade, cada decisão, cada escolha importa. ",
      author: {
        name: "Rodolfo Sikora, Programador da H9K Quant",
        // "picture": "https://i.pravatar.cc/150?img=70"
      },
    },
  },
  stats: {
    title: "Alguns números da H9K Quant",
    subtitle: "Experiência que gera resultados, inovação que transforma seu trading.",
    data: [
      {
        value: "7 anos",
        description: "de experiencia",
      },
      {
        value: "4 anos",
        description: "de Trading automatizado",
      },
      {
        value: "+20k",
        description: "contratos operados por mês",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da H9K Quant?",
    subtitle: "Veja quais as principais vantagens dos robôs da H9K Quant.",
    data: [
      {
        title: "100% Automatizado",
        description:
          "Nossos robôs executam todas as operações de forma autônoma, ajustando estratégias sem necessidade de intervenção manual. ",
      },
      {
        title: "Suporte Personalizado ",
        description:
          "Atendimento exclusivo de assessores que dominam as estratégias e estão prontos para atender você. ",
      },
      {
        title: "Execução Precisa",
        description:
          "Algoritmos que analisam o mercado em tempo real, garantindo decisões mais rápidas do que qualquer trader humano.",
      },
      {
        title: "Alto Desempenho",
        description: "Estratégias testadas e otimizadas para potencializar seus resultados no mercado. ",
      },
      {
        title: "Ganhe Tempo",
        description:
          "Deixe a automação operar para você enquanto foca em outras atividades, sem precisar acompanhar o mercado o tempo todo.",
      },
      {
        title: "Elimine o Fator Emociona",
        description:
          "Evite decisões impulsivas ou baseadas no medo. Com automação, suas operações seguem a estratégia definida com disciplina. ",
      },
    ],
  },
  cta: {
    title: "Pronto para deixar o mercado trabalhar para você?",
    subtitle: "Ative Agora mesmo a extensão H9K Quant",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A H9K Quant",
    col1: [
      "Na H9K Quant, unimos tecnologia e experiência para transformar a forma como traders operam. Nascemos da parceria entre um programador experiente e um trader com mais de 7 anos de atuação no day trade, combinando conhecimento de mercado e inovação para criar soluções eficientes. ",
    ],
    col2: [
      "Nosso foco é a automação de operações na bolsa, priorizando precisão, qualidade e estratégias estatisticamente comprovadas. Acreditamos que o sucesso vem da consistência, por isso desenvolvemos modelos que garantem execuções precisas e reduzem a influência emocional. ",
      "Mais do que automação, oferecemos segurança e confiabilidade. Nossa missão é ajudar traders a operarem com mais estratégia e assertividade, proporcionando resultados sólidos e sustentáveis. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da H9K Quant",
  },
  strategies: {
    title: "Estratégias H9K Quant",
    heading: "Automatize seu sucesso com a H9K Quant.",
    subtitle:
      "Leve a qualidade da H9K Quant para sua conta com nossos robôs. Estratégia, precisão e automação para resultados consistentes, enquanto você foca no que realmente importa. ",
  },
  testimonials: [
    {
      text: "Estou muito satisfeito com as estratégias automatizadas de day trade. Elas equilibram rentabilidade e segurança, mesmo no curto prazo. Confio nos resultados e acredito que podem ajudar mais pessoas a alcançar seus objetivos financeiros.",
      author: "Cristofer Dutra",
      job: "Nutricionista",
      // "image_url": "https://avatars.githubusercontent.com/u/97165289"
    },
    {
      text: "Depois de me aposentar, queria uma renda extra sem ficar o dia todo na frente do computador. Com os robôs da H9K Quant, meu dinheiro trabalha por mim enquanto aproveito a vida. ",
      author: "Rudney Pereira",
      job: "Aposentado ",
      // "image_url": "https://avatars.githubusercontent.com/u/97165289"
    },
  ],
};
